import { useState } from 'react';
import type { FaqItem } from '@/mocks/types';

interface Props {
  items: FaqItem[];
  defaultOpen?: number;
}

export default function FaqAccordion({ items, defaultOpen = 0 }: Props) {
  const [open, setOpen] = useState<number | null>(defaultOpen);

  return (
    <div className="divide-y divide-background-200 overflow-hidden rounded-lg border border-background-200 bg-background-50">
      {items.map((item, index) => {
        const isOpen = open === index;
        return (
          <div key={item.question}>
            <h3>
              <button
                type="button"
                aria-expanded={isOpen}
                onClick={() => setOpen(isOpen ? null : index)}
                className="flex w-full items-center justify-between gap-4 px-5 py-4 text-left transition-colors hover:bg-background-100"
              >
                <span className="flex items-start gap-3">
                  <span className="mt-0.5 flex h-6 w-6 shrink-0 items-center justify-center rounded-md bg-primary-100 text-xs font-bold text-primary-700">
                    Q
                  </span>
                  <span className="font-heading text-base font-bold text-foreground-950">
                    {item.question}
                  </span>
                </span>
                <i
                  className={`shrink-0 text-xl text-foreground-400 transition-transform ${
                    isOpen ? 'ri-subtract-line rotate-180' : 'ri-add-line'
                  }`}
                ></i>
              </button>
            </h3>
            {isOpen && (
              <div className="px-5 pb-5 pl-14">
                <p className="text-sm leading-relaxed text-foreground-700">{item.answer}</p>
              </div>
            )}
          </div>
        );
      })}
    </div>
  );
}